import { render } from "./TipsSequence.vue?vue&type=template&id=0270fea2"
import script from "./TipsSequence.vue?vue&type=script&lang=js"
export * from "./TipsSequence.vue?vue&type=script&lang=js"
script.render = render

export default script